import { Component, OnInit } from '@angular/core';
import { BaseModalComponent } from 'app/shared/base-modal/base-modal.component';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-modifier-groups-modal',
  templateUrl: './edit-modifier-groups-modal.component.html',
  styleUrls: ['./edit-modifier-groups-modal.component.scss']
})
export class EditModifierGroupsModalComponent extends BaseModalComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<any>) {
    super(dialogRef);
  }

  ngOnInit(): void {
    console.log("ngOnInit");
  }

}
